export type UserSource = 'sso' | 'manual';

export type UserRole =
  | 'Administrator'
  | 'TeamAdministrator'
  | 'RoleAdministrator'
  | 'ServiceEditor'
  | 'CapabilityAdministrator'
  | 'MetaModelEditor'
  | 'Read-Only';

export const ALL_ROLES: UserRole[] = [
  'Administrator',
  'TeamAdministrator',
  'RoleAdministrator',
  'ServiceEditor',
  'CapabilityAdministrator',
  'MetaModelEditor',
  'Read-Only',
];

/**
 * Human-readable display labels for each role.
 *
 * The stored role identifiers (e.g. `ServiceEditor`) are not user-friendly.
 * UI surfaces should render these labels instead of the raw identifier.
 */
export const ROLE_LABELS: Record<UserRole, string> = {
  Administrator: 'Administrator',
  TeamAdministrator: 'Team Administrator',
  RoleAdministrator: 'Role Administrator',
  ServiceEditor: 'Service Editor',
  CapabilityAdministrator: 'Capability Administrator',
  MetaModelEditor: 'Meta Model Editor',
  'Read-Only': 'Read-Only',
};

/**
 * Return the human-readable label for a role identifier.
 *
 * Falls back to the raw value for any unknown role so the UI never renders
 * an empty cell if the role set drifts from the type.
 */
export function getRoleLabel(role: string): string {
  return ROLE_LABELS[role as UserRole] ?? role;
}

export interface PlatformUser {
  userId: string;
  email: string;
  name: string;
  roles: UserRole[];
  source: UserSource;
  lastLoggedInAt?: string;
  _createdAt: string;
  _updatedAt: string;
}

export interface CreatePlatformUserInput {
  email: string;
  name: string;
  roles: UserRole[];
}

export interface UpdateUserRolesInput {
  roles: UserRole[];
}
